/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Errors_Failedtorefresh2Inputs */

const id_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal menyegarkan profil`)
};

const ms_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal menyegarkan profil`)
};

const da_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opdatering af profil mislykkedes`)
};

const de_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisierung des Profils fehlgeschlagen`)
};

const en_us2_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to refresh profile`)
};

const es_es2_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar el perfil`)
};

const es_mx2_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al actualizar el perfil`)
};

const fil_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigong i-refresh ang profile`)
};

const fr_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'actualisation du profil`)
};

const it_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento profilo fallito`)
};

const hu_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A profil frissítése sikertelen`)
};

const nl_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiel vernieuwen mislukt`)
};

const no_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke oppdatere profilen`)
};

const pl_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się odświeżyć profilu`)
};

const pt_br2_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar o perfil`)
};

const pt_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar o perfil`)
};

const ro_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reîmprospătarea profilului a eșuat`)
};

const fi_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profiilin päivitys epäonnistui`)
};

const sv_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uppdatering av profilen misslyckades`)
};

const vi_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Làm mới hồ sơ thất bại`)
};

const tr_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil yenilenemedi`)
};

const cs_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovení profilu se nezdařilo`)
};

const bg_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неуспешно опресняване на профила`)
};

const ru_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось обновить профиль`)
};

const uk_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося оновити профіль`)
};

const ar_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشل تحديث الملف الشخصي`)
};

const hi_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोफ़ाइल रिफ्रेश करने में विफल`)
};

const th_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีเฟรชโปรไฟล์ไม่สำเร็จ`)
};

const ja_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロフィールの更新に失敗しました`)
};

const zh_cn2_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新个人资料失败`)
};

const zh_hant1_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新整理個人資料失敗`)
};

const ko_profile_errors_failedtorefresh2 = /** @type {(inputs: Profile_Errors_Failedtorefresh2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프로필 새로고침 실패`)
};

/**
* | output |
* | --- |
* | "Failed to refresh profile" |
*
* @param {Profile_Errors_Failedtorefresh2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_errors_failedtorefresh2 = /** @type {((inputs?: Profile_Errors_Failedtorefresh2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Errors_Failedtorefresh2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_errors_failedtorefresh2(inputs)
	if (locale === "ms") return ms_profile_errors_failedtorefresh2(inputs)
	if (locale === "da") return da_profile_errors_failedtorefresh2(inputs)
	if (locale === "de") return de_profile_errors_failedtorefresh2(inputs)
	if (locale === "en-US") return en_us2_profile_errors_failedtorefresh2(inputs)
	if (locale === "es-ES") return es_es2_profile_errors_failedtorefresh2(inputs)
	if (locale === "es-MX") return es_mx2_profile_errors_failedtorefresh2(inputs)
	if (locale === "fil") return fil_profile_errors_failedtorefresh2(inputs)
	if (locale === "fr") return fr_profile_errors_failedtorefresh2(inputs)
	if (locale === "it") return it_profile_errors_failedtorefresh2(inputs)
	if (locale === "hu") return hu_profile_errors_failedtorefresh2(inputs)
	if (locale === "nl") return nl_profile_errors_failedtorefresh2(inputs)
	if (locale === "no") return no_profile_errors_failedtorefresh2(inputs)
	if (locale === "pl") return pl_profile_errors_failedtorefresh2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_errors_failedtorefresh2(inputs)
	if (locale === "pt") return pt_profile_errors_failedtorefresh2(inputs)
	if (locale === "ro") return ro_profile_errors_failedtorefresh2(inputs)
	if (locale === "fi") return fi_profile_errors_failedtorefresh2(inputs)
	if (locale === "sv") return sv_profile_errors_failedtorefresh2(inputs)
	if (locale === "vi") return vi_profile_errors_failedtorefresh2(inputs)
	if (locale === "tr") return tr_profile_errors_failedtorefresh2(inputs)
	if (locale === "cs") return cs_profile_errors_failedtorefresh2(inputs)
	if (locale === "bg") return bg_profile_errors_failedtorefresh2(inputs)
	if (locale === "ru") return ru_profile_errors_failedtorefresh2(inputs)
	if (locale === "uk") return uk_profile_errors_failedtorefresh2(inputs)
	if (locale === "ar") return ar_profile_errors_failedtorefresh2(inputs)
	if (locale === "hi") return hi_profile_errors_failedtorefresh2(inputs)
	if (locale === "th") return th_profile_errors_failedtorefresh2(inputs)
	if (locale === "ja") return ja_profile_errors_failedtorefresh2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_errors_failedtorefresh2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_errors_failedtorefresh2(inputs)
	return ko_profile_errors_failedtorefresh2(inputs)
});
export { profile_errors_failedtorefresh2 as "profile.errors.failedToRefresh" }